import { Component, inject } from '@angular/core';
import { Item, ItemActionResult, ItemProvider } from '@ntap/core';
import { PrimeNGButtonNewItemViewActionComponent } from '@ntap/primeng';
import { first, Observable } from 'rxjs';
@Component({
  selector: 'app-add-object-to-parent-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class AddObjectToParentActionComponent extends PrimeNGButtonNewItemViewActionComponent {
  myitemProvider = inject(ItemProvider);

  protected override doExecuteWithItem(
    item: Item
  ): Observable<ItemActionResult> {
    this.action.isItemView = true;
    const mainTypeId: string = item['$mainType' as keyof typeof item] + '~id';
    this.addSubscription(
      this.myitemProvider.item$.pipe(first()).subscribe((olditem) => {
        (item as any)['$parentId'] = (olditem as any)[mainTypeId];
      })
    );
    return super.doExecuteWithItem(item).pipe();
  }
}
